import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, withStyles } from '@material-ui/core';
import { FolderNav, Loader, Theme } from '@orijinworks/frontend-commons';
import styles from './ReentryPlanningModule.styles';
import ReentryPlansTable from './components/ReentryPlansTable';
import withRolePermission from '../Feeds/withRolePermission';
import Forms from '../../Form/Forms';
import { FORM_SOURCE } from '../../Form/constants/form-source.constants';
import {
  ACCESS_STATUS,
  useReentryPlanningModuleHook,
} from './useReentryPlanningModuleHook';

function ReentryPlanningModule({ classes }) {
  const {
    accessStatus,
    activeTab,
    activeTabConfig,
    entitledPlanTypes,
    isFormsTabActive,
    lastRefreshed,
    onTabChange,
    refreshPlans,
    tabs,
  } = useReentryPlanningModuleHook();

  if (accessStatus === ACCESS_STATUS.DENIED) {
    return <Navigate to="/home" replace />;
  }

  if (accessStatus === ACCESS_STATUS.PENDING) {
    return <Loader isLoading />;
  }

  return (
    <Theme>
      <Box
        className={classes.application}
        role="main"
        aria-label="Re-Entry Planning"
        id="reentry-plans-content"
      >
        <Box className={classes.folderWrapper}>
          <FolderNav
            scrollButtons={false}
            tabFontColor="var(--blue-main)"
            tabs={tabs}
            defaultActiveTab={activeTab}
            onTabChange={onTabChange}
            role="tablist"
            aria-label="Re-Entry Planning navigation tabs"
          >
            {isFormsTabActive ? (
              <div
                role="tabpanel"
                aria-labelledby={activeTabConfig.tabId}
                id={activeTabConfig.panelId}
                style={{ height: '93%' }}
              >
                <Forms source={FORM_SOURCE.REENTRY_PLANNING} />
              </div>
            ) : (
              <Box
                role="tabpanel"
                aria-labelledby={activeTabConfig.tabId}
                id={activeTabConfig.panelId}
                className={classes.tabPanel}
              >
                <ReentryPlansTable
                  entitledPlanTypes={entitledPlanTypes}
                  lastRefreshed={lastRefreshed}
                  listScope={activeTabConfig.listScope}
                  onRefreshHandler={refreshPlans}
                  title={activeTabConfig.label}
                />
              </Box>
            )}
          </FolderNav>
        </Box>
      </Box>
    </Theme>
  );
}

/**
 * HOC that fetches Janus `/user/token` before rendering Re-Entry Planning (All Plans).
 * Ensures CBAC checks and plan APIs have a fresh Janus token on screen load.
 */
const StyledReentryPlanningModule = withStyles(styles)(ReentryPlanningModule);

export default withRolePermission(StyledReentryPlanningModule);
